import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WorkExperienceLevelsService } from 'src/app/services/workexperiencelevels.service';
import { WorkexperiencelevelsModalComponent } from './workexperiencelevels-modal/workexperiencelevels-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-workexperiencelevels',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './workexperiencelevels.component.html',
  styleUrl: './workexperiencelevels.component.css'
})
export class WorkExperienceLevelsComponent implements OnInit {
  
  WorkExperienceLevelsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  constructor(
      private dialog: MatDialog,
      private WorkExperienceLevelsService: WorkExperienceLevelsService,
      private changeDetectorRef: ChangeDetectorRef
    ) {} 

  ngOnInit(): void {
      this.getWorkExperienceLevels();
  }

  getWorkExperienceLevels(){
    this.WorkExperienceLevelsService.getWorkExperienceLevels().subscribe({
      next: (res: any) => {
        this.WorkExperienceLevelsList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar niveles de experiencia:', err);
        this.filteredData = [];
      }
    });
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(WorkexperiencelevelsModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getWorkExperienceLevels();
        }
      }
    });
  }
}
